import { render } from "./InputLinks.vue?vue&type=template&id=d18d512a&scoped=true&ts=true"
import script from "./InputLinks.vue?vue&type=script&lang=ts"
export * from "./InputLinks.vue?vue&type=script&lang=ts"

import "./InputLinks.vue?vue&type=style&index=0&id=d18d512a&lang=scss&scoped=true"

import exportComponent from "/mnt/c/Users/mssuzuki/work/fidev/nicotto/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d18d512a"]])

export default __exports__